import React from 'react';

export const EmailDraft = ({ width = 20, height = 20, className = '' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_12682_1265984)">
      <path
        d="M16.666 10.4173V5.83398C16.666 5.61297 16.5782 5.40107 16.4219 5.24479C16.2656 5.08851 16.0537 5.00065 15.8327 5.00065H4.16602C3.945 5.00065 3.7331 5.08851 3.57682 5.24479C3.42054 5.40107 3.33268 5.61297 3.33268 5.83398V14.1673C3.33268 14.3883 3.42054 14.6002 3.57682 14.7565C3.7331 14.9128 3.945 15.0007 4.16602 15.0007H9.99935C10.4596 15.0007 10.8327 15.3737 10.8327 15.834C10.8327 16.2942 10.4596 16.6673 9.99935 16.6673H4.16602C3.50297 16.6673 2.86728 16.4037 2.39844 15.9349C1.9296 15.4661 1.66602 14.8304 1.66602 14.1673V5.83398C1.66602 5.17094 1.9296 4.53525 2.39844 4.06641C2.86728 3.59757 3.50297 3.33398 4.16602 3.33398H15.8327C16.4957 3.33398 17.1314 3.59757 17.6003 4.06641C18.0691 4.53525 18.3327 5.17094 18.3327 5.83398V10.4173C18.3327 10.8776 17.9596 11.2507 17.4993 11.2507C17.0391 11.2507 16.666 10.8776 16.666 10.4173Z"
        fill="#991B1B"
      />
      <path
        d="M17.0372 5.14005C17.4201 4.88475 17.9375 4.98823 18.1928 5.37117C18.4481 5.75411 18.3446 6.27147 17.9617 6.52677L10.4617 11.5268C10.1817 11.7134 9.8171 11.7134 9.53718 11.5268L2.03718 6.52677C1.65424 6.27147 1.55077 5.75411 1.80606 5.37117C2.06136 4.98823 2.57872 4.88475 2.96166 5.14005L9.99942 9.83162L17.0372 5.14005Z"
        fill="#991B1B"
      />
      <path
        d="M16.6667 13.7957C16.6667 13.6922 16.6228 13.5801 16.5243 13.4881C16.4238 13.3945 16.2759 13.3327 16.1108 13.3327H14.7225C14.5574 13.3327 14.4096 13.3945 14.3091 13.4881C14.2106 13.5801 14.1667 13.6922 14.1667 13.7957V16.8328L14.9764 16.3291L15.0806 16.2738C15.3302 16.1637 15.6211 16.1824 15.8569 16.3291L16.6667 16.8328V13.7957ZM18.3333 18.3327C18.3333 18.6353 18.169 18.9141 17.9045 19.061C17.6399 19.2079 17.3166 19.1997 17.0597 19.0399L15.4167 18.0177L13.7736 19.0399C13.5167 19.1997 13.1934 19.2079 12.9289 19.061C12.6643 18.9141 12.5 18.6353 12.5 18.3327V13.7957C12.5 13.2117 12.749 12.6641 13.1714 12.2699C13.5918 11.8774 14.151 11.666 14.7225 11.666H16.1108C16.6824 11.666 17.2415 11.8774 17.6619 12.2699C18.0843 12.6641 18.3333 13.2117 18.3333 13.7957V18.3327Z"
        fill="#991B1B"
      />
    </g>
    <defs>
      <clipPath id="clip0_12682_1265984">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
